var popupStatus = 0;
//loading popup with jQuery magic!
function loadPopup() {
    //loads popup only if it is disabled
    if (popupStatus == 0) {
        $("#backgroundPopup").css({
            "opacity": "0.9"
        });
        $("#backgroundPopup").fadeIn("slow");
        $("#popupContact").fadeIn("slow");
        popupStatus = 1;
    }
}
//disabling popup with jQuery magic!
function disablePopup() {
    //disables popup only if it is enabled
    if (popupStatus == 1) {
        $("#backgroundPopup").fadeOut("slow");
        $("#popupContact").fadeOut("slow");
        popupStatus = 0;
    }
}
//centering popup
function centerPopup() {
    //request data for centering
    var windowWidth = document.documentElement.clientWidth;
    var windowHeight = document.documentElement.clientHeight;
    var popupHeight = $("#popupContact").height();
    var popupWidth = $("#popupContact").width();
    //centering
    $("#popupContact").css({
        "top": windowHeight / 2 - popupHeight / 2,
        //"top": 20,
        "left": windowWidth / 2 - popupWidth / 2
    });
    //only need force for IE6
    $("#backgroundPopup").css({
        "height": windowHeight
    });
}

$(document).ready(function () {
	var s = $.session.get('p')
	if(!$.session.get('p') || s < 1)
	{
		// centerPopup();
        setTimeout(function() {
            loadPopup();
        }, 10000);
	}

    //Click the button event!
    $("#button").click(function() {
        // centerPopup();
        loadPopup();
		$.session.set('p', '1');
    });
    //CLOSING POPUP
    //Click the x event!
    $("#popupContactClose, #popupContact a").click(function() {
        disablePopup();
		$.session.set('p', '1');
		//$.cookie("showpopup",null);
    });
    //Click out event!
    $("#backgroundPopup").click(function() {
		disablePopup();
		$.session.set('p', '1');
    });
    //Press Escape event!
    $(document).keypress(function(e) {
        if (e.keyCode == 27 && popupStatus == 1) {
            disablePopup();
			//$.cookie("showpopup",null);
			$.session.set('p', '1');
        }
    });
});


$('#popup_frm_contact').submit(function(event) {
    event.preventDefault();

    var elem = $(this);

    $.ajax({
        url: elem.attr('action'),
        type: "post",
        // dataType: "json",
        data: elem.serialize(),
        beforeSend: function() {
            elem.addClass('disabled');
            elem.find('.contact_sub').addClass('disabled');
            $(".contact_view").show().css("color","#f00").html("Đang load dữ liệu ...");
            window.clearTimeout();
        },
        success: function(res){
            if(res.success == false){
                $(".contact_view").show();
                $(".contact_view").css("color","#f00").html("Vui lòng nhập đầy đủ thông tin");
            }else{
                $(".contact_view").show();
                $(".contact_view").html("<span style='color:#639537;font-weight:bold;'>Ý kiến của bạn đã được gửi, chúng tôi liên hệ với bạn trong thời gian gần nhất.</span>");
                setTimeout(function () {
                    $("#popupContact a").trigger("click");
                }, 3000);
            }
            elem.removeClass('disabled');
            elem.find('.contact_sub').removeClass('disabled');
        }
    });

    return false;
});
